import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedSite: null,
};

const selectedSiteSlice = createSlice({
  name: 'selectedSite',
  initialState,
  reducers: {
    setSelectedSite: (state, action) => {
      state.selectedSite = action.payload;
    },
    clearSelectedSite: (state) => {
      state.selectedSite = null;
    },
  },
});

export const { setSelectedSite,clearSelectedSite } = selectedSiteSlice.actions;
export default selectedSiteSlice.reducer;
